{
  "analysis_structured": {
    "c1_ethics_concern": false,
    "c1_observed_only": true,
    "c2_note": "There are no behavioral markers for this competency area. Maintaining a coaching mindset — staying open, curious, flexible and client-centered — develops across a coach's professional journey and cannot be evaluated from a single recorded session. This competency is therefore not assigned a level and does not affect the overall level decision.",
    "c2_transcript_assessed": false,
    "competency_analyses": {
      "C1": {
        "additional_evidence": [],
        "competency_code": "C1",
        "development_examples": [],
        "level": "",
        "narrative": "Observed. Conduct consistent with ethical practice and the coaching role was observed in this session, and no behaviour contrary to the ethical standards was observed. Ethical practice is a threshold to be met rather than a skill level, so this competency is not assigned a level and does not affect the overall level decision.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "What would make this conversation useful for you today?",
            "rationale": "Invites client ownership from the outset.",
            "timestamp": "02:12"
          }
        ]
      },
      "C2": {
        "additional_evidence": [],
        "competency_code": "C2",
        "development_examples": [],
        "level": "",
        "narrative": "There are no behavioral markers for this competency area. Maintaining a coaching mindset — staying open, curious, flexible and client-centered — develops across a coach's professional journey and cannot be evaluated from a single recorded session. This competency is therefore not assigned a level and does not affect the overall level decision.",
        "positive_examples": []
      },
      "C3": {
        "additional_evidence": [],
        "competency_code": "C3",
        "development_examples": [],
        "level": "pcc",
        "narrative": "The agreement is specific and remains connected to the client’s desired outcome.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "If we get to the end with clarity, what will be different for you?",
            "rationale": "Clarifies the session outcome in observable terms.",
            "timestamp": "03:04"
          }
        ]
      },
      "C4": {
        "additional_evidence": [],
        "competency_code": "C4",
        "development_examples": [],
        "level": "pcc",
        "narrative": "The client is given permission to think aloud without judgment.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "Take your time. There is no right answer here.",
            "rationale": "Supports psychological safety and reflection.",
            "timestamp": "09:36"
          }
        ]
      },
      "C5": {
        "additional_evidence": [],
        "competency_code": "C5",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "timestamp": "19:18"
          }
        ],
        "level": "pcc",
        "narrative": "Presence is grounded and responsive; the next edge is using silence after high-value questions.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "What is happening for you as you sit with that?",
            "rationale": "Brings attention to the client’s present experience.",
            "timestamp": "21:10"
          }
        ]
      },
      "C6": {
        "additional_evidence": [],
        "competency_code": "C6",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "timestamp": "24:33"
          }
        ],
        "level": "mcc",
        "narrative": "The coach listens beyond content for identity, energy, and shifts in meaning.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "When you say “reliable,” what does that word ask you to carry?",
            "rationale": "Uses the client’s language to explore meaning.",
            "timestamp": "12:41"
          }
        ]
      },
      "C7": {
        "additional_evidence": [],
        "competency_code": "C7",
        "development_examples": [
          {
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Contains an implied solution.",
            "timestamp": "19:18"
          }
        ],
        "level": "pcc",
        "narrative": "Awareness is evoked through concise questions connected to the client’s identity and choices.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "What becomes possible if reliability includes asking for help?",
            "rationale": "Invites a reframing grounded in the client’s own theme.",
            "timestamp": "14:08"
          },
          {
            "marker_ids": [],
            "quote": "What would a version of that boundary sound like in your own voice?",
            "rationale": "Moves awareness toward authentic expression.",
            "timestamp": "28:06"
          }
        ]
      },
      "C8": {
        "additional_evidence": [],
        "competency_code": "C8",
        "development_examples": [],
        "level": "pcc",
        "narrative": "The client authors a measurable experiment and names the support needed to follow through.",
        "positive_examples": [
          {
            "marker_ids": [],
            "quote": "What small experiment are you willing to run this week?",
            "rationale": "Turns insight into a client-owned action.",
            "timestamp": "31:52"
          },
          {
            "marker_ids": [],
            "quote": "What will tell you on Friday that this experiment helped?",
            "rationale": "Invites the client to define success evidence.",
            "timestamp": "34:27"
          }
        ]
      }
    },
    "competency_decision_table": [
      {
        "competency_code": "C1",
        "competency_name": "Demonstrates Ethical Practice",
        "confidence": null,
        "inconsistent_patterns": [],
        "level": "",
        "level_label": "Observed",
        "summary": "Observed. Conduct consistent with ethical practice and the coaching role was observed in this session, and no behaviour contrary to the ethical standards was observed. Ethical practice is a threshold to be met rather than a skill level, so this competency is not assigned a level and does not affect the overall level decision."
      },
      {
        "competency_code": "C2",
        "competency_name": "Embodies Coaching Mindset",
        "confidence": null,
        "inconsistent_patterns": [],
        "level": "",
        "level_label": "—",
        "summary": "There are no behavioral markers for this competency area. Maintaining a coaching mindset — staying open, curious, flexible and client-centered — develops across a coach's professional journey and cannot be evaluated from a single recorded session. This competency is therefore not assigned a level and does not affect the overall level decision."
      },
      {
        "competency_code": "C3",
        "competency_name": "Establishes and Maintains Agreements",
        "confidence": 0.93,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC level",
        "summary": "The agreement is specific and remains connected to the client’s desired outcome."
      },
      {
        "competency_code": "C4",
        "competency_name": "Cultivates Trust and Safety",
        "confidence": 0.94,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC level",
        "summary": "The client is given permission to think aloud without judgment."
      },
      {
        "competency_code": "C5",
        "competency_name": "Maintains Presence",
        "confidence": 0.86,
        "inconsistent_patterns": [
          "Occasional stacked questions reduce reflective space."
        ],
        "level": "pcc",
        "level_label": "PCC level",
        "summary": "Presence is grounded and responsive; the next edge is using silence after high-value questions."
      },
      {
        "competency_code": "C6",
        "competency_name": "Listens Actively",
        "confidence": 0.95,
        "inconsistent_patterns": [],
        "level": "mcc",
        "level_label": "MCC level",
        "summary": "The coach listens beyond content for identity, energy, and shifts in meaning."
      },
      {
        "competency_code": "C7",
        "competency_name": "Evokes Awareness",
        "confidence": 0.91,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC level",
        "summary": "Awareness is evoked through concise questions connected to the client’s identity and choices."
      },
      {
        "competency_code": "C8",
        "competency_name": "Facilitates Client Growth",
        "confidence": 0.92,
        "inconsistent_patterns": [],
        "level": "pcc",
        "level_label": "PCC level",
        "summary": "The client authors a measurable experiment and names the support needed to follow through."
      }
    ],
    "competency_levels": {
      "C3": "pcc",
      "C4": "pcc",
      "C5": "pcc",
      "C6": "mcc",
      "C7": "pcc",
      "C8": "pcc"
    },
    "competency_verdicts": {
      "C3": {
        "confidence": 0.93,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "If we get to the end with clarity, what will be different for you?",
            "timestamp": "03:04"
          }
        ],
        "summary": "The agreement is specific and remains connected to the client’s desired outcome."
      },
      "C4": {
        "confidence": 0.94,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "Take your time. There is no right answer here.",
            "timestamp": "09:36"
          }
        ],
        "summary": "The client is given permission to think aloud without judgment."
      },
      "C5": {
        "confidence": 0.86,
        "development_evidence": [
          {
            "quote": "And what would happen if you delegated that — would your team step up?",
            "timestamp": "19:18"
          }
        ],
        "inconsistent_patterns": [
          "Occasional stacked questions reduce reflective space."
        ],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "What is happening for you as you sit with that?",
            "timestamp": "21:10"
          }
        ],
        "summary": "Presence is grounded and responsive; the next edge is using silence after high-value questions."
      },
      "C6": {
        "confidence": 0.95,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "mcc",
        "positive_evidence": [
          {
            "quote": "When you say “reliable,” what does that word ask you to carry?",
            "timestamp": "12:41"
          },
          {
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "timestamp": "24:33"
          }
        ],
        "summary": "The coach listens beyond content for identity, energy, and shifts in meaning."
      },
      "C7": {
        "confidence": 0.91,
        "development_evidence": [
          {
            "quote": "And what would happen if you delegated that — would your team step up?",
            "timestamp": "19:18"
          }
        ],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "What becomes possible if reliability includes asking for help?",
            "timestamp": "14:08"
          },
          {
            "quote": "What would a version of that boundary sound like in your own voice?",
            "timestamp": "28:06"
          }
        ],
        "summary": "Awareness is evoked through concise questions connected to the client’s identity and choices."
      },
      "C8": {
        "confidence": 0.92,
        "development_evidence": [],
        "inconsistent_patterns": [],
        "level": "pcc",
        "positive_evidence": [
          {
            "quote": "What small experiment are you willing to run this week?",
            "timestamp": "31:52"
          },
          {
            "quote": "What will tell you on Friday that this experiment helped?",
            "timestamp": "34:27"
          }
        ],
        "summary": "The client authors a measurable experiment and names the support needed to follow through."
      }
    },
    "development_areas": [
      {
        "marker_ids": [],
        "quote": "And what would happen if you delegated that — would your team step up?",
        "rationale": "Stacks two questions and suggests a direction.",
        "timestamp": "19:18"
      },
      {
        "marker_ids": [],
        "quote": "Your pace changed when you said “permission.” What are you noticing?",
        "rationale": "Surfaces a tonal shift without interpreting it for the client.",
        "timestamp": "24:33"
      }
    ],
    "level_decision": {
      "caveat": "This is not an ICF pass/fail statement; it is an evidence-based internal level estimate for training and mentor coaching.",
      "competency_level_counts": {
        "mcc": 1,
        "pcc": 5
      },
      "confidence_band": "medium",
      "confidence_label": "Medium",
      "decision_competencies": [
        "C3",
        "C4",
        "C5",
        "C6",
        "C7",
        "C8"
      ],
      "limiting_competencies": [
        "C3",
        "C4",
        "C5",
        "C7",
        "C8"
      ],
      "non_decision_competencies": [
        "C1",
        "C2"
      ],
      "overall_level": "pcc",
      "overall_level_label": "PCC level",
      "rationale": "The overall decision is PCC level; the competency distribution (PCC level: 5, MCC level: 1) and structured evidence screening support it as the most balanced internal estimate. This decision basis uses C3-C8 behaviors; C1 and C2 are reported but not counted as direct level drivers. Strong supporting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively.",
      "supporting_competencies": [
        "C3",
        "C4",
        "C5",
        "C6",
        "C7",
        "C8"
      ],
      "why_not_higher": "Not MCC level, because the next-level behaviors are not consistent enough across the full session. Limiting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C7 Evokes Awareness. Main limiting pattern: Occasional stacked questions reduce reflective space.",
      "why_not_lower": "Not PCC preparation band or lower, because there is consistent coaching evidence above that level: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively."
    },
    "mentor_detailed_report": {
      "calibration_notes": [],
      "development_opportunities": [
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "And what would happen if you delegated that — would your team step up?",
              "rationale": "Stacks two questions and suggests a direction.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Stacks two questions and suggests a direction."
        },
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Your pace changed when you said “permission.” What are you noticing?",
              "rationale": "Surfaces a tonal shift without interpreting it for the client.",
              "source": "development",
              "timestamp": "24:33"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Surfaces a tonal shift without interpreting it for the client."
        },
        {
          "competency_code": "C5",
          "competency_name": "Maintains Presence",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "And what would happen if you delegated that — would your team step up?",
              "rationale": "Stacks two questions and suggests a direction.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Stacks two questions and suggests a direction."
        },
        {
          "competency_code": "C6",
          "competency_name": "Listens Actively",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Your pace changed when you said “permission.” What are you noticing?",
              "rationale": "Surfaces a tonal shift without interpreting it for the client.",
              "source": "development",
              "timestamp": "24:33"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Surfaces a tonal shift without interpreting it for the client."
        },
        {
          "competency_code": "C7",
          "competency_name": "Evokes Awareness",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "And what would happen if you delegated that — would your team step up?",
              "rationale": "Contains an implied solution.",
              "source": "development",
              "timestamp": "19:18"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "development",
          "statement_refs": [],
          "summary": "Contains an implied solution."
        }
      ],
      "evidence_map": [
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "When you say “reliable,” what does that word ask you to carry?",
          "rationale": "Uses the client’s language to explore meaning.",
          "source": "strengths",
          "timestamp": "12:41"
        },
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "And what would happen if you delegated that — would your team step up?",
          "rationale": "Stacks two questions and suggests a direction.",
          "source": "development_areas",
          "timestamp": "19:18"
        },
        {
          "competency_code": "",
          "marker_ids": [],
          "quote": "Your pace changed when you said “permission.” What are you noticing?",
          "rationale": "Surfaces a tonal shift without interpreting it for the client.",
          "source": "development_areas",
          "timestamp": "24:33"
        },
        {
          "competency_code": "C1",
          "marker_ids": [],
          "quote": "What would make this conversation useful for you today?",
          "rationale": "Invites client ownership from the outset.",
          "source": "C1.positive_examples",
          "timestamp": "02:12"
        },
        {
          "competency_code": "C3",
          "marker_ids": [],
          "quote": "If we get to the end with clarity, what will be different for you?",
          "rationale": "Clarifies the session outcome in observable terms.",
          "source": "C3.positive_examples",
          "timestamp": "03:04"
        },
        {
          "competency_code": "C4",
          "marker_ids": [],
          "quote": "Take your time. There is no right answer here.",
          "rationale": "Supports psychological safety and reflection.",
          "source": "C4.positive_examples",
          "timestamp": "09:36"
        }
      ],
      "language": "en",
      "level_reasoning": {
        "c1_c2_boundary": "C1 is treated as an ethics/role-boundary gate; C2 is derived from transcript behavior and is not used to inflate the level decision.",
        "decision_basis": "The overall decision is PCC level; the competency distribution (PCC level: 5, MCC level: 1) and structured evidence screening support it as the most balanced internal estimate. This decision basis uses C3-C8 behaviors; C1 and C2 are reported but not counted as direct level drivers. Strong supporting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively.",
        "why_not_higher": "Not MCC level, because the next-level behaviors are not consistent enough across the full session. Limiting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C7 Evokes Awareness. Main limiting pattern: Occasional stacked questions reduce reflective space.",
        "why_not_lower": "Not PCC preparation band or lower, because there is consistent coaching evidence above that level: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively."
      },
      "level_summary": {
        "competing_level": null,
        "confidence_band": "medium",
        "estimated_level": "pcc",
        "level_label": "PCC level",
        "level_semantics": "closest_demonstrated_level",
        "review_recommended": false
      },
      "limitations": [
        "This report is not an official ICF credentialing decision; it provides evidence-based developmental feedback for live mentor coaching preparation."
      ],
      "live_mentor_session_questions": [
        {
          "question": "When reviewing the moment at 19:18, “And what would happen if you delegated that — would your team step up?”, did the coach deepen the client's insight or move the focus to action too quickly?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development",
            "timestamp": "19:18"
          },
          "why_discuss_with_mentor": "This question helps the live mentor coaching session review behavioral evidence and choose a more precise practice focus."
        },
        {
          "question": "For the moment at 24:33, “Your pace changed when you said “permission.” What are you noticing?”, what shorter, more client-led intervention would the mentor coach try?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "source": "development",
            "timestamp": "24:33"
          },
          "why_discuss_with_mentor": "This question helps the live mentor coaching session review behavioral evidence and choose a more precise practice focus."
        },
        {
          "question": "Under what conditions could the strength shown in the moment at 12:41, “When you say “reliable,” what does that word ask you to carry?” be sustained more consistently across the session?",
          "related_competency": "",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "When you say “reliable,” what does that word ask you to carry?",
            "rationale": "Uses the client’s language to explore meaning.",
            "source": "strength",
            "timestamp": "12:41"
          },
          "why_discuss_with_mentor": "This question helps the live mentor coaching session review behavioral evidence and choose a more precise practice focus."
        },
        {
          "question": "What does the moment at 02:12, “What would make this conversation useful for you today?” show about working with the client's meaning world, relationship quality, or coaching presence?",
          "related_competency": "C1",
          "transcript_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "What would make this conversation useful for you today?",
            "rationale": "Invites client ownership from the outset.",
            "source": "strength",
            "timestamp": "02:12"
          },
          "why_discuss_with_mentor": "This question helps the live mentor coaching session review behavioral evidence and choose a more precise practice focus."
        }
      ],
      "next_level_shift": [
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development",
            "timestamp": "19:18"
          },
          "related_competency": "",
          "summary": "To move toward MCC level, the coach's work in this competency needs to stay more client-led, evidence-sensitive, and insight-deepening.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "source": "development",
            "timestamp": "24:33"
          },
          "related_competency": "",
          "summary": "To move toward MCC level, the coach's work in this competency needs to stay more client-led, evidence-sensitive, and insight-deepening.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development",
            "timestamp": "19:18"
          },
          "related_competency": "C5",
          "summary": "To move toward MCC level, the coach's work in C5 needs to stay more client-led, evidence-sensitive, and insight-deepening.",
          "target_level": "mcc"
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "source": "development",
            "timestamp": "24:33"
          },
          "related_competency": "C6",
          "summary": "To move toward MCC level, the coach's work in C6 needs to stay more client-led, evidence-sensitive, and insight-deepening.",
          "target_level": "mcc"
        }
      ],
      "next_session_practice_plan": [
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development",
            "timestamp": "19:18"
          },
          "practice_focus": "For the selected competency, try a shorter, clearer, more client-led intervention in the next session.",
          "related_competency": "",
          "success_indicator": "The client expresses their insight, choice, or next step more in their own words."
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "source": "development",
            "timestamp": "24:33"
          },
          "practice_focus": "For the selected competency, try a shorter, clearer, more client-led intervention in the next session.",
          "related_competency": "",
          "success_indicator": "The client expresses their insight, choice, or next step more in their own words."
        },
        {
          "evidence_anchor": {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development",
            "timestamp": "19:18"
          },
          "practice_focus": "For C5, try a shorter, clearer, more client-led intervention in the next session.",
          "related_competency": "C5",
          "success_indicator": "The client expresses their insight, choice, or next step more in their own words."
        }
      ],
      "public_boundary": "This report is not an official ICF credentialing decision; it provides evidence-based developmental feedback for live mentor coaching preparation.",
      "session_snapshot": "**Performing at PCC.** The coach consistently partners with the client, listens for meaning beneath the words, and turns emerging awareness into a client-owned experiment. The clearest next edge is to allow more silence before adding a second question.",
      "strengths": [
        {
          "competency_code": "",
          "competency_name": "",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "When you say “reliable,” what does that word ask you to carry?",
              "rationale": "Uses the client’s language to explore meaning.",
              "source": "strength",
              "timestamp": "12:41"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Uses the client’s language to explore meaning."
        },
        {
          "competency_code": "C1",
          "competency_name": "Demonstrates Ethical Practice",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "What would make this conversation useful for you today?",
              "rationale": "Invites client ownership from the outset.",
              "source": "strength",
              "timestamp": "02:12"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Invites client ownership from the outset."
        },
        {
          "competency_code": "C3",
          "competency_name": "Establishes and Maintains Agreements",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "If we get to the end with clarity, what will be different for you?",
              "rationale": "Clarifies the session outcome in observable terms.",
              "source": "strength",
              "timestamp": "03:04"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Clarifies the session outcome in observable terms."
        },
        {
          "competency_code": "C4",
          "competency_name": "Cultivates Trust and Safety",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "Take your time. There is no right answer here.",
              "rationale": "Supports psychological safety and reflection.",
              "source": "strength",
              "timestamp": "09:36"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Supports psychological safety and reflection."
        },
        {
          "competency_code": "C5",
          "competency_name": "Maintains Presence",
          "evidence": [
            {
              "competency_code": "",
              "marker_ids": [],
              "quote": "What is happening for you as you sit with that?",
              "rationale": "Brings attention to the client’s present experience.",
              "source": "strength",
              "timestamp": "21:10"
            }
          ],
          "evidence_needed": false,
          "feedback_type": "strength",
          "statement_refs": [],
          "summary": "Brings attention to the client’s present experience."
        }
      ],
      "template_id": "mentor_detailed_v1",
      "upper_level_nuance_profile": {
        "bias_boundary": "This assessment is grounded in observable coaching behaviors rather than pace, language fluency, energy level, or personal style.",
        "client_meaning_world": "not_observed",
        "coaching_presence": "not_observed",
        "depth_of_exploration": "not_observed",
        "evidence": [
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "When you say “reliable,” what does that word ask you to carry?",
            "rationale": "Uses the client’s language to explore meaning.",
            "source": "strengths",
            "timestamp": "12:41"
          },
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "And what would happen if you delegated that — would your team step up?",
            "rationale": "Stacks two questions and suggests a direction.",
            "source": "development_areas",
            "timestamp": "19:18"
          },
          {
            "competency_code": "",
            "marker_ids": [],
            "quote": "Your pace changed when you said “permission.” What are you noticing?",
            "rationale": "Surfaces a tonal shift without interpreting it for the client.",
            "source": "development_areas",
            "timestamp": "24:33"
          },
          {
            "competency_code": "C1",
            "marker_ids": [],
            "quote": "What would make this conversation useful for you today?",
            "rationale": "Invites client ownership from the outset.",
            "source": "C1.positive_examples",
            "timestamp": "02:12"
          }
        ],
        "facilitates_growth_impact": "not_observed",
        "limitations": [
          "This profile surfaces upper-level qualities; the current evidence is not used by itself to claim an MCC-adjacent result."
        ],
        "mcc_adjacent_signal": false,
        "public_boundary": "This section is not an official MCC scoring formula. It makes upper-level coaching qualities visible developmentally.",
        "relationship_quality": "not_observed",
        "subtlety_and_artistry": "not_observed"
      }
    },
    "overall_assessment": "**Performing at PCC.** The coach consistently partners with the client, listens for meaning beneath the words, and turns emerging awareness into a client-owned experiment. The clearest next edge is to allow more silence before adding a second question.",
    "overall_level": "pcc",
    "phase2_contract": "competency_v1",
    "recommendations": [
      "Ask one question at a time after emotionally significant client statements.",
      "Let two full breaths pass before adding language when the client is reflecting.",
      "Keep linking action design back to the identity shift the client named."
    ],
    "requested_level": null,
    "review_recommended": false,
    "strengths": [
      {
        "marker_ids": [],
        "quote": "When you say “reliable,” what does that word ask you to carry?",
        "rationale": "Uses the client’s language to explore meaning.",
        "timestamp": "12:41"
      }
    ],
    "what_who_balance": "balanced"
  },
  "analysis_text": "### SECTION 0: LEVEL DECISION\n**OVERALL LEVEL:** PCC level\n**CONFIDENCE:** Medium\n**Decision basis:** The overall decision is PCC level; the competency distribution (PCC level: 5, MCC level: 1) and structured evidence screening support it as the most balanced internal estimate. This decision basis uses C3-C8 behaviors; C1 and C2 are reported but not counted as direct level drivers. Strong supporting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively.\n**Why not higher:** Not MCC level, because the next-level behaviors are not consistent enough across the full session. Limiting areas: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C7 Evokes Awareness. Main limiting pattern: Occasional stacked questions reduce reflective space.\n**Why not lower:** Not PCC preparation band or lower, because there is consistent coaching evidence above that level: C3 Establishes and Maintains Agreements, C4 Cultivates Trust and Safety, C5 Maintains Presence, C6 Listens Actively.\n**Note:** This is not an ICF pass/fail statement; it is an evidence-based internal level estimate for training and mentor coaching.\n\n### SECTION 1: OVERALL ASSESSMENT\n\nMETRICS:\n- What/Who Balance: Balanced\n\n**Performing at PCC.** The coach consistently partners with the client, listens for meaning beneath the words, and turns emerging awareness into a client-owned experiment. The clearest next edge is to allow more silence before adding a second question.\n\nCONCLUSION: These characteristics are consistent with PCC level level.\n\n### SECTION 2: STRENGTHS\n- (12:41) \"When you say “reliable,” what does that word ask you to carry?\" - Uses the client’s language to explore meaning.\n\n### SECTION 3: DEVELOPMENT AREAS\n- (19:18) \"And what would happen if you delegated that — would your team step up?\" - Stacks two questions and suggests a direction.\n- (24:33) \"Your pace changed when you said “permission.” What are you noticing?\" - Surfaces a tonal shift without interpreting it for the client.\n\n### SECTION 4: DETAILED COMPETENCY ANALYSIS\n\n| Competency | Level | Evidence Summary |\n|------------|-------|------------------|\n| 1. Demonstrates Ethical Practice | Observed | Observed. |\n| 2. Embodies Coaching Mindset | — | There are no behavioral markers for this competency area. |\n| 3. Establishes and Maintains Agreements | PCC level | The agreement is specific and remains connected to the client’s desired outcome. |\n| 4. Cultivates Trust and Safety | PCC level | The client is given permission to think aloud without judgment. |\n| 5. Maintains Presence | PCC level | Presence is grounded and responsive; the next edge is using silence after high-value questions. |\n| 6. Listens Actively | MCC level | The coach listens beyond content for identity, energy, and shifts in meaning. |\n| 7. Evokes Awareness | PCC level | Awareness is evoked through concise questions connected to the client’s identity and choices. |\n| 8. Facilitates Client Growth | PCC level | The client authors a measurable experiment and names the support needed to follow through. |\n\n**1. Demonstrates Ethical Practice**\nObserved. Conduct consistent with ethical practice and the coaching role was observed in this session, and no behaviour contrary to the ethical standards was observed. Ethical practice is a threshold to be met rather than a skill level, so this competency is not assigned a level and does not affect the overall level decision.\nPositive Example: (02:12) \"What would make this conversation useful for you today?\" - Invites client ownership from the outset.\n\n**2. Embodies Coaching Mindset**\nThere are no behavioral markers for this competency area. Maintaining a coaching mindset — staying open, curious, flexible and client-centered — develops across a coach's professional journey and cannot be evaluated from a single recorded session. This competency is therefore not assigned a level and does not affect the overall level decision.\n\n**3. Establishes and Maintains Agreements**\nLevel: PCC level\nThe agreement is specific and remains connected to the client’s desired outcome.\nPositive Example: (03:04) \"If we get to the end with clarity, what will be different for you?\" - Clarifies the session outcome in observable terms.\n\n**4. Cultivates Trust and Safety**\nLevel: PCC level\nThe client is given permission to think aloud without judgment.\nPositive Example: (09:36) \"Take your time. There is no right answer here.\" - Supports psychological safety and reflection.\n\n**5. Maintains Presence**\nLevel: PCC level\nPresence is grounded and responsive; the next edge is using silence after high-value questions.\nPositive Example: (21:10) \"What is happening for you as you sit with that?\" - Brings attention to the client’s present experience.\nDevelopment Example: (19:18) \"And what would happen if you delegated that — would your team step up?\" - Stacks two questions and suggests a direction.\n\n**6. Listens Actively**\nLevel: MCC level\nThe coach listens beyond content for identity, energy, and shifts in meaning.\nPositive Example: (12:41) \"When you say “reliable,” what does that word ask you to carry?\" - Uses the client’s language to explore meaning.\nDevelopment Example: (24:33) \"Your pace changed when you said “permission.” What are you noticing?\" - Surfaces a tonal shift without interpreting it for the client.\n\n**7. Evokes Awareness**\nLevel: PCC level\nAwareness is evoked through concise questions connected to the client’s identity and choices.\nPositive Example: (14:08) \"What becomes possible if reliability includes asking for help?\" - Invites a reframing grounded in the client’s own theme.\nPositive Example: (28:06) \"What would a version of that boundary sound like in your own voice?\" - Moves awareness toward authentic expression.\nDevelopment Example: (19:18) \"And what would happen if you delegated that — would your team step up?\" - Contains an implied solution.\n\n**8. Facilitates Client Growth**\nLevel: PCC level\nThe client authors a measurable experiment and names the support needed to follow through.\nPositive Example: (31:52) \"What small experiment are you willing to run this week?\" - Turns insight into a client-owned action.\nPositive Example: (34:27) \"What will tell you on Friday that this experiment helped?\" - Invites the client to define success evidence.\n\n### SECTION 5: RECOMMENDATIONS\n- Ask one question at a time after emotionally significant client statements.\n- Let two full breaths pass before adding language when the client is reflecting.\n- Keep linking action design back to the identity shift the client named.\n\n**OVERALL LEVEL (Summary):** PCC level",
  "meta": {
    "client_name": "Maya Reed (fictional)",
    "coach_name": "Elena Hart (fictional)",
    "duration_minutes": 38,
    "is_fictional": true,
    "language": "en",
    "sample_version": 3,
    "source": "Grading-engine inputs taken from the previous hand-authored sample (frontend/src/data/sampleReport.ts + sampleReport.* copy). TODO: regenerate from a real run of the agentic grading engine on a fictional transcript.",
    "title": "PCC demo session — finding a sustainable leadership rhythm"
  }
}
